import AddPlace from './AddPlace';

export default AddPlace; 